module.exports = ".container {\n  padding-bottom: 20px; }\n\n.text-container {\n  min-width: 240px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/common/blocked-modal/blocked-modal.component.scss
// module id = ./src/app/modules/boxoffice-module/common/blocked-modal/blocked-modal.component.scss
// module chunks = 9